<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Editar perfil</h1>
    <p class="text-lg md:text-xl">
      Consulta y actualiza tu información personal.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="w-full xl:w-2/4">
    @if (loadingProfile) {
    <div class="flex flex-col gap-5">
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
      <div class="w-64 h-10 bg-gray-200 cursor-wait animate-pulse"></div>
    </div>
    } @else {
    <form class="flex flex-col" [formGroup]="form" (ngSubmit)="saveProfile()">
      <mat-form-field>
        <mat-label>Nombre</mat-label>
        <input
          type="text"
          name="displayName"
          formControlName="displayName"
          matInput
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Nombre de usuario</mat-label>
        <input
          type="text"
          name="username"
          formControlName="username"
          matInput
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Correo electrónico</mat-label>
        <input type="text" name="email" formControlName="email" matInput />
      </mat-form-field>

      <!-- Errores -->
      @if (errors) {
      <div class="flex flex-col gap-2 text-center lg:text-start mt-5">
        @for (error of errors; track error) {
        <span class="text-sm text-red-500">{{ error }}</span>
        }
      </div>
      }

      <button
        type="submit"
        mat-flat-button
        class="lg:w-64 mt-10"
        [disabled]="form.invalid || loadingSaveProfile"
      >
        @if (loadingSaveProfile) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Guardar</span>
        }
      </button>
    </form>
    }
  </section>
</div>
